import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Star, Heart, User, Send, X } from 'lucide-react';
interface Comment {
  id: number;
  name: string;
  avatar: string;
  rating: number;
  text: string;
  likes: number;
  timeAgo: string;
}
export function CommentsSection() {
  const initialComments: Comment[] = [{
    id: 1,
    name: 'Diego Fernández',
    avatar: 'DF',
    rating: 5,
    text: 'Loco esto es oro puro, yo venia re trabado sin saber que hacer y con esto en una semana ya arranque. Los bonos estan re buenos tambien, el de presupuestar me re sirvio para no regalar el laburo',
    likes: 24,
    timeAgo: 'hace 3 horas'
  }, {
    id: 2,
    name: 'Cristian Molina',
    avatar: 'CM',
    rating: 5,
    text: 'La mejor inversion que hice este año hermano, ya recupere la guita y ahora estoy generando ingresos todos los dias. Super recomendable para el que quiere emprender',
    likes: 31,
    timeAgo: 'hace 5 horas'
  }, {
    id: 3,
    name: 'Pablo Ruiz',
    avatar: 'PR',
    rating: 5,
    text: 'Che muy completo todo, tiene banda de info util. Yo pensaba que iba a ser mas complicado pero esta re bien explicado paso a paso, cualquiera lo puede hacer',
    likes: 18,
    timeAgo: 'hace 8 horas'
  }, {
    id: 4,
    name: 'Javier Sosa',
    avatar: 'JS',
    rating: 4,
    text: 'Esta bueno, me sirvio bastante para ordenar las ideas y saber que comprar. Lo unico que me hubiera gustado es mas ejemplos practicos pero bueno por el precio esta joya',
    likes: 12,
    timeAgo: 'hace 12 horas'
  }, {
    id: 5,
    name: 'Marcelo Giménez',
    avatar: 'MG',
    rating: 5,
    text: 'Excelente material loco, yo arranque hace un mes y ya tengo varios clientes fijos. La guia de mecanica tambien me re ayudo porque ahora ofrezco mas servicios y gano mas',
    likes: 27,
    timeAgo: 'hace 1 día'
  }];
  const [comments, setComments] = useState<Comment[]>(initialComments);
  const [newComment, setNewComment] = useState('');
  const [newRating, setNewRating] = useState(5);
  const [showModal, setShowModal] = useState(false);
  const [visibleComments, setVisibleComments] = useState(5);
  const [likedComments, setLikedComments] = useState<Set<number>>(new Set());
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!newComment.trim()) return;
    const comment: Comment = {
      id: Date.now(),
      name: 'Usuario Anónimo',
      avatar: 'UA',
      rating: newRating,
      text: newComment,
      likes: 0,
      timeAgo: 'justo ahora'
    };
    setComments([comment, ...comments]);
    setNewComment('');
    setNewRating(5);
    setShowModal(true);
  };
  const handleLike = (id: number) => {
    if (likedComments.has(id)) {
      setLikedComments(prev => {
        const newSet = new Set(prev);
        newSet.delete(id);
        return newSet;
      });
      setComments(comments.map(c => c.id === id ? {
        ...c,
        likes: c.likes - 1
      } : c));
    } else {
      setLikedComments(prev => new Set(prev).add(id));
      setComments(comments.map(c => c.id === id ? {
        ...c,
        likes: c.likes + 1
      } : c));
    }
  };
  const loadMore = () => {
    setVisibleComments(prev => Math.min(prev + 5, comments.length + 30));
  };
  return <section className="py-20 px-4 bg-[#0a0a0a]" data-id="element-61">
      <div className="max-w-4xl mx-auto" data-id="element-62">
        <h2 className="text-4xl md:text-5xl font-black text-center mb-12" data-id="element-63">
          Comentarios de la <span className="text-brand-yellow" data-id="element-64">Comunidad</span>
        </h2>

        <div className="bg-[#1a1a1a] border-2 border-gray-800 rounded-3xl p-6 md:p-8 mb-8 shadow-2xl" data-id="element-65">
          <h3 className="text-2xl font-bold mb-6 flex items-center gap-3" data-id="element-66">
            <Send className="w-6 h-6 text-brand-yellow" data-id="element-67" />
            Dejá tu opinión
          </h3>

          <form onSubmit={handleSubmit} className="space-y-6" data-id="element-68">
            <div data-id="element-69">
              <label className="block text-sm font-bold text-gray-400 mb-3 uppercase tracking-wide" data-id="element-70">
                Tu calificación
              </label>
              <div className="flex gap-2" data-id="element-71">
                {[1, 2, 3, 4, 5].map(star => <button key={star} type="button" onClick={() => setNewRating(star)} className="transition-transform hover:scale-110" data-id="element-72">
                    <Star className={`w-8 h-8 ${star <= newRating ? 'fill-brand-yellow text-brand-yellow' : 'text-gray-600'}`} data-id="element-73" />
                  </button>)}
              </div>
            </div>

            <div data-id="element-74">
              <label className="block text-sm font-bold text-gray-400 mb-3 uppercase tracking-wide" data-id="element-75">
                Tu comentario
              </label>
              <textarea value={newComment} onChange={e => setNewComment(e.target.value)} placeholder="Compartí tu experiencia con la formación..." className="w-full bg-[#0a0a0a] border-2 border-gray-700 rounded-xl p-4 text-white placeholder-gray-500 focus:border-brand-yellow focus:outline-none transition-colors min-h-[120px] resize-none" data-id="element-76" />
            </div>

            <button type="submit" className="w-full bg-gradient-to-r from-brand-yellow to-brand-gold text-black font-bold py-4 px-6 rounded-xl text-lg flex items-center justify-center gap-3 hover:scale-105 transition-transform shadow-lg" data-id="element-77">
              <Send className="w-5 h-5" data-id="element-78" />
              Publicar Comentario
            </button>
          </form>
        </div>

        <div className="space-y-6" data-id="element-79">
          {comments.slice(0, visibleComments).map((comment, index) => <motion.div key={comment.id} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: index * 0.05
        }} className="bg-[#1a1a1a] border border-gray-800 rounded-2xl p-6 hover:border-gray-700 transition-colors shadow-lg" data-id="element-80">
              <div className="flex items-start gap-4 mb-4" data-id="element-81">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-brand-yellow to-brand-gold flex items-center justify-center flex-shrink-0 font-bold text-black" data-id="element-82">
                  {comment.avatar}
                </div>

                <div className="flex-1" data-id="element-83">
                  <div className="flex items-center justify-between mb-2" data-id="element-84">
                    <div data-id="element-85">
                      <p className="font-bold text-white text-lg" data-id="element-86">
                        {comment.name}
                      </p>
                      <p className="text-sm text-gray-500" data-id="element-87">{comment.timeAgo}</p>
                    </div>
                    <div className="flex gap-1" data-id="element-88">
                      {[...Array(comment.rating)].map((_, i) => <Star key={i} className="w-4 h-4 fill-brand-yellow text-brand-yellow" data-id="element-89" />)}
                    </div>
                  </div>

                  <p className="text-gray-300 leading-relaxed mb-4" data-id="element-90">
                    {comment.text}
                  </p>

                  <button onClick={() => handleLike(comment.id)} className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-colors ${likedComments.has(comment.id) ? 'bg-red-500/20 text-red-500' : 'bg-gray-800 text-gray-400 hover:bg-gray-700'}`} data-id="element-91">
                    <Heart className={`w-5 h-5 ${likedComments.has(comment.id) ? 'fill-current' : ''}`} data-id="element-92" />
                    <span className="font-bold" data-id="element-93">{comment.likes}</span>
                  </button>
                </div>
              </div>
            </motion.div>)}
        </div>

        {visibleComments < comments.length + 30 && <motion.button initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} onClick={loadMore} className="mt-8 w-full bg-[#1a1a1a] border-2 border-brand-yellow text-brand-yellow font-bold py-4 px-6 rounded-xl text-lg hover:bg-brand-yellow hover:text-black transition-all" data-id="element-94">
            Cargar 5 comentarios más
          </motion.button>}

        <AnimatePresence data-id="element-95">
          {showModal && <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4" onClick={() => setShowModal(false)} data-id="element-96">
              <motion.div initial={{
            scale: 0.9,
            opacity: 0
          }} animate={{
            scale: 1,
            opacity: 1
          }} exit={{
            scale: 0.9,
            opacity: 0
          }} className="bg-[#1a1a1a] border-2 border-brand-yellow rounded-3xl p-8 max-w-md w-full relative" onClick={e => e.stopPropagation()} data-id="element-97">
                <button onClick={() => setShowModal(false)} className="absolute top-4 right-4 text-gray-500 hover:text-white transition-colors" data-id="element-98">
                  <X className="w-6 h-6" data-id="element-99" />
                </button>

                <div className="text-center" data-id="element-100">
                  <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-101">
                    <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-102">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" data-id="element-103" />
                    </svg>
                  </div>

                  <h3 className="text-2xl font-black text-white mb-3" data-id="element-104">
                    ¡Gracias por tu comentario!
                  </h3>
                  <p className="text-gray-400 text-lg mb-6" data-id="element-105">
                    Tu opinión ayuda a la comunidad.
                  </p>

                  <button onClick={() => setShowModal(false)} className="bg-gradient-to-r from-brand-yellow to-brand-gold text-black font-bold py-3 px-8 rounded-xl hover:scale-105 transition-transform" data-id="element-106">
                    Cerrar
                  </button>
                </div>
              </motion.div>
            </motion.div>}
        </AnimatePresence>
      </div>
    </section>;
}